import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchResult, deepCopy } from 'src/app/shared';
import { UserActions } from 'src/app/shared/models/user';
import { Excel, ExportRequest, UserRoleService } from '../..';

@Component({
    selector: 'app-search-controller-list',
    template: `
    <app-list
      [dataSource]="searchResults"
      [template]="row"
      class="app-pt2"
      [filterEnabled]="true"
      loadingMessage=""
      noDataIcon="search"
      noDataMessage="No results"
      noDataThinMessage="There are no results that match the search"
      [pageSizeOptions]="[5, 10, 25]"
      [pageSize]="10"
      [exportEnabled]="true"
      exportButtonAriaLabel="Export and download these controller as a XLSX file"
      (export)="_export()"
      [tableAriaLabel]="'Search Results'"
    >
      <ng-container header>
        <tr class="tw-flex tw-flex-wrap tw-w-full">
          <app-list-header
            name="name"
            label="Name"
            class="tw-w-full md:tw-w-[50%]"
          ></app-list-header>

          <app-list-header
            name="email"
            label="Email"
            class="tw-w-full md:tw-w-[50%]"
          >
          </app-list-header>
          
        </tr>
      </ng-container>
    </app-list>

    <ng-template #row let-element role="rowgroup">
      <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
        <td class="tw-w-full md:tw-w-[50%]">
          <app-value label="Name" layout="row-xs" [valueTemplate]="claimantLabelTpl">
            <ng-template #claimantLabelTpl>
            <app-claimant-label
              [claimant]="element"
              [disabled]="!claimantLabelLink"
                [isController]="isController"
            >
            </app-claimant-label>
            </ng-template>
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[50%]">
          <app-value
            label="Email"
            [tabindex]="element.email ? '0' : '1'"
            layout="row-xs"
            [value]="element.email"
          >
          </app-value>
        </td>       
      </tr>
    </ng-template>
  `,
    styles: ``,
    standalone: false
})
export class SearchControllerListComponent {
  @Input()
  searchResults: SearchResult[];

  @Input()
  excelName: string = 'Employee Search';

  @Input()
  sheetName: string = 'Employee Search';

  @Output()
  export = new EventEmitter<ExportRequest>();

  @Input()
  isController:boolean = false;

  userAction = UserActions.ViewOwnMgrDb;

  claimantLabelLink = false;

  constructor(private excel: Excel, public userRole: UserRoleService) {
    this.claimantLabelLink = this.userRole.manager || this.userRole.auditor;
  }

  _export() {
    const request = new ExportRequest();
    const claimRows = deepCopy(this.searchResults);
    request.fileName = this.excelName;
    request.sheets = [
      {
        name: this.sheetName,
        rows: claimRows,
        headers: [
          { label: 'Name', value: 'name', format:'first' },
          { label: 'Email ID', value: 'email' },
        ],
      },
    ];

    this.export.emit(request);
    this.excel.export(request, [], '.xlsx');
  }
}
